import React from 'react';
import useFileUpload from '../../hooks/useFileUpload';
import UploadDrop from './UploadDrop';
import FilePreview from './FilePreview';
import UploadPreview from './UploadPreview';
import { S3File } from './types';
import { IconType } from '../Icon/Icon';
import { Accept } from 'react-dropzone';

type UploadSelectPreviewProps = {
  accept?: Accept;
  icon?: IconType;
  existingFile?: S3File | null;
  uploadState: ReturnType<typeof useFileUpload>;
  previewBackgroundColor?: string;
  size?: number;
  readOnly?: boolean;
};

const UploadSelectPreview: React.FC<UploadSelectPreviewProps> = (props) => {
  const { previewUrl, acceptedFile } = props.uploadState;

  if (props.readOnly) {
    if (props.existingFile) {
      return (
        <FilePreview
          file={props.existingFile}
          backgroundColor={props.previewBackgroundColor}
          size={props.size ?? 300}
        />
      );
    }

    return <></>;
  }

  return (
    <UploadDrop
      accept={props.accept}
      icon={props.icon}
      dropZone={props.uploadState}
    >
      {acceptedFile && previewUrl && (
        <UploadPreview
          file={acceptedFile}
          previewUrl={previewUrl}
          backgroundColor={props.previewBackgroundColor}
          size={props.size ?? 300}
        />
      )}
      {!acceptedFile && props.existingFile && (
        <FilePreview
          file={props.existingFile}
          backgroundColor={props.previewBackgroundColor}
          size={props.size ?? 300}
        />
      )}
    </UploadDrop>
  );
};

export default UploadSelectPreview;
